export type ToastType =
  | 'STANDARD'
  | 'PREMIUM'
  | 'SUCCESS'
  | 'WARNING'
  | 'ERROR';
export type ToastTimeout = 'NONE' | 'NORMAL';
export type ToastPriority = 'LOW' | 'NORMAL' | 'HIGH';

export type ToastActionUiType = 'BUTTON' | 'LINK';

export type ToastAction = {
  text: string;
  onClick?: Function;
  removeToastOnClick?: boolean;
  uiType?: ToastActionUiType;
  navigationTarget?: {
    url: string;
    openInNewTab?: boolean;
  };
};

export type ErrorToastDetails = {
  requestId: string;
};

export type ToastConfig = {
  message: string;
  biName?: string;
  timeout?: ToastTimeout;
  priority?: ToastPriority;
  type?: ToastType;
  onCloseClick?: () => unknown;
  onToastSeen?: () => unknown;
  action?: ToastAction;
  details?: ErrorToastDetails;
};

export type RemoveToast = () => void;

export type ShowToast = (toastConfig: ToastConfig) => {
  remove: RemoveToast;
};
